import { Box, Skeleton } from '@mui/material'
import { styles } from './style'

export function FormulaSkeleton() {
  return (
    <Box sx={styles.row} aria-label='Formula skeleton'>
      <Skeleton width={120} height={32} />
    </Box>
  )
}
